import { useState, useRef } from 'react';
import Accordion from './Accordion';

import {
  createTask,
  submitTask,
  upgradeUserTask,
} from '../../../redux/actions/contentPayer';
import useFileUpload from 'react-use-file-upload';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Gamification from '../../../components/Gamification';
import { useGamification } from '../../../context/GamificationContext';
import { discountActivity, userActivity } from '../../../common/constants';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useEffect } from 'react';
import { TaskList } from './TaskList';
import { GradeCard } from './GradeCard';
import Spinner from '../../../components/Spinner';

export default function Task({
  task,
  circularProgressbar,
  taskAction,
  setTaskAction
  // , skillName, mskillName
}) {
  const [showAttachments, setShowAttachments] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isUpgraded, setIsUpgraded] = useState(false);
  const [submittedTask, setSubmittedTask] = useState(null);
  const [spinner, setSpinner] = useState(false);
  const {
    files,
    // fileNames,
    // fileTypes,
    // totalSize,
    // totalSizeInBytes,
    // handleDragDropEvent,
    clearAllFiles,
    // createFormData,
    setFiles,
    removeFile,
  } = useFileUpload();
  const { setOpenConfirmationModal, setType } = useGamification();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const inputRef = useRef();
  const user_token = useSelector((store) => store?.authentication?.user_token);

  useEffect(() => {
    clearAllFiles();
    setIsSubmitted(task?.user_task ? true : false);
    // setIsReSubmitted(
    //   task?.user_task?.reviewed_status === 'resubmission' &&
    //     task?.user_task?.review_status_resubmission === 'none'
    //     ? false
    //     : true
    // );
    setIsUpgraded(
      task?.user_task?.task_upgraded_for_expert_response ? true : false
    );
    setSubmittedTask(null);
    setSpinner(false);
  }, [task.id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (user_token) {
      if (files.length === 0) {
        toast.info('Please attach file');
        return;
      }
      var formData = new FormData();
      for (const file of files) {
        formData.append('upload_files[]', file);
      }
      setSpinner(true);
      dispatch(
        createTask(
          task?.mskill_id,
          task?.id,
          (res) => {
            dispatch(
              submitTask(
                res?.id,
                formData,
                '',
                res?.reviewed_status === 'resubmission'
                  ? 'resubmission'
                  : 'submission',
                (res) => {
                  // console.log('res111', res);
                 setTaskAction(!taskAction)
                  toast.success('Task submitted successfully');
                  clearAllFiles();
                  setIsSubmitted(true);
                  setSubmittedTask({ user_task: res });
                  setSpinner(false)
                },
                (err) => {}
              )
            );
          },
          (err) => {}
        )
      );
    } else {
      navigate('/login');
    }
  };

  function expertTaskHandler() {
    dispatch(
      upgradeUserTask(task?.id, (successObj) => {
        // console.log('successObj', successObj);
        setTaskAction(!taskAction);
        toast.success('Expert review requested successfully');
        setIsUpgraded(true);
        setSubmittedTask({ user_task: successObj });
      })
    );
  }

  const taskSubmitted = submittedTask ? submittedTask : task;
  //console.log(task);
  const taskExpertReviewStatus = taskSubmitted?.user_task
    ? taskSubmitted?.user_task?.review_status_resubmission === 'none'
      ? taskSubmitted?.user_task?.review_status !== 'none'
        ? taskSubmitted?.user_task?.review_status === 'pending' ||
          taskSubmitted?.user_task?.review_status === 'in_review'
          ? 'In Review'
          : 'Reviewed'
        : 'Review pending'
      : taskSubmitted?.user_task?.review_status_resubmission === 'pending'
      ? 'Re-Submit'
      : taskSubmitted?.user_task?.review_status_resubmission === 'in_review'
      ? 'In Review'
      : 'Reviewed'
    : 'Incomplete';

  const data = ['About the Task'];

  taskSubmitted?.user_task?.review_rating && data.push('Grade');
  taskSubmitted?.user_task?.review_rating_resubmission &&
    data.push('Resubmission');

  return (
    <div className="w-full space-y-2 px-2 md:w-5/6 ">
      <div className="flex items-center justify-between text-sm font-semibold text-[#7B7B7B] md:text-base">
        {/* <div>{  task?.skill_name}>{ task?.mSkill_name}</div> */}
        <div>
          {task?.['skill-name']}
          <FontAwesomeIcon icon={faChevronRight} className="mx-2" />
          {task?.['mSkill-name']}
        </div>
        {circularProgressbar()}
      </div>
      {data.map((item, id) => (
        <Accordion
          title={item}
          id={id}
          key={id}
          expertStatus={taskExpertReviewStatus}
        >
          {item === data[0] && (
            <div className="p-1 px-2">
              <h2 className="py-2 font-semibold text-[#050505]">Question</h2>
              <div className="text-xs  md:text-sm" dangerouslySetInnerHTML={{__html : task?.task_question}}/>
              <h2 className="mt-2 py-2 font-semibold text-[#050505]">
                Description
              </h2>
              <div className="text-xs  md:text-sm" dangerouslySetInnerHTML={{__html : task?.task_description}} />
              <div className="flex items-center justify-between">
                <h2 className="mt-2 py-2 font-semibold text-[#050505]">
                  Reference File
                </h2>

                <div
                  className="mt-2 cursor-pointer text-right text-sm font-bold text-[#077070] underline"
                  onClick={() => setShowAttachments(!showAttachments)}
                >
                  {showAttachments ? 'Hide' : 'See Attachments'}
                </div>
              </div>
              {showAttachments && (
                <div className="overflow-hidden   ">
                  <ul className=" min-w-full">
                    {task?.task_attachments.map((item, idx) => (
                      <li
                        key={idx}
                        className="  my-2   rounded bg-[#B7E7D2]
                       shadow-md"
                        // style={{ 'border-radius': '14px !important' }}
                      >
                        <div className="rounded-xxl px-2 py-3  md:px-6">
                          <div className="flex justify-between">
                            <div className="flex items-center">
                              <div className="flex-shrink-0">
                                <img
                                  className=""
                                  src={
                                    'https://assets.learntube.ai/files/Content_player/Attachment_Paper.png?ik-sdk-version=javascript-1.4.3&updatedAt=1662805197601'
                                  }
                                  alt="attachment"
                                />
                              </div>
                              <div className="ml-2">
                                <div className="text-sm font-semibold text-[#225A42]">
                                  {item.name}
                                </div>
                              </div>
                            </div>
                            <div className="text-sm font-semibold text-[#15422E] ">
                              <a
                                href={item?.url}
                                download
                                className="underline"
                                target={'_blank'}
                                rel="noreferrer"
                              >
                                View
                              </a>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {isSubmitted && (
                <TaskList
                  title={'Submitted Tasks'}
                  uploadedFiles={taskSubmitted?.user_task?.uploaded_files}
                  submittedAt={taskSubmitted?.user_task?.submitted_at}
                />
              )}
              {taskSubmitted?.user_task?.uploaded_files_resubmission && (
                <TaskList
                  title={'Resubmitted Tasks'}
                  uploadedFiles={
                    taskSubmitted?.user_task?.uploaded_files_resubmission
                  }
                  submittedAt={
                    taskSubmitted?.user_task?.submitted_at_resubmission
                  }
                />
              )}
              {(!isSubmitted ||
                (taskSubmitted?.user_task?.reviewed_status === 'resubmission' &&
                  !taskSubmitted?.user_task?.uploaded_files_resubmission)) && (
                <>
                  <h2 className="py-2 font-semibold text-[#050505]">
                    {taskSubmitted?.user_task?.reviewed_status ===
                    'resubmission'
                      ? 'Resubmit Your Tasks'
                      : 'Upload your task here'}
                  </h2>
                  <div>
                    <div>
                      <div>
                        <button
                          className="w-full rounded-lg border-2 border-dashed border-[#059C9C] bg-[#E9FFFF] py-3 text-center font-semibold text-[#077070]"
                          onClick={() => inputRef.current.click()}
                        >
                          <img
                            src="https://assets.learntube.ai/files/Content_player/Group_5496.png?ik-sdk-version=javascript-1.4.3&updatedAt=1662828476371"
                            alt="icon"
                            srcset=""
                            className="mx-auto inline-block"
                          />
                          <span className="ml-2">Upload Here</span>{' '}
                        </button>
                        <div className="flex justify-between py-2">
                          <div className="text-xs text-[#8E8E8E]">
                            Image/Zip/pdf/xls/ppt/doc
                          </div>
                          <div className="text-xs font-semibold text-[#7A7A7A]">
                            Max file limit 6 MB
                          </div>
                        </div>
                        {/* Hide the crappy looking default HTML input */}
                        <input
                          ref={inputRef}
                          type="file"
                          multiple
                          style={{ display: 'none' }}
                          onChange={(e) => {
                            // console.log( files.length)
                            if (
                              e.target.files[e.target.files.length - 1].size <
                                6291456 &&
                              files.length < 4 &&
                              e.target.files.length < 5
                            ) {
                              if (
                                e.target.files[
                                  e.target.files.length - 1
                                ].name.match(
                                  /\.(jpg|jpeg|png|doc|docx|xls|xlsx|pdf|zip)$/
                                )
                              ) {
                                setFiles(e, 'a');
                                inputRef.current.value = null;
                              } else {
                                // inputRef.current.value = null;
                                toast.info(
                                  'Allowed File Types(image/ zip/ pdf/ xls/ ppt/ doc)'
                                );
                              }
                            } else {
                              toast.info(
                                'File size should be less than 6 MB and maximum 4 files can be uploaded'
                              );
                            }
                          }}
                        />
                      </div>
                      <h2 className="py-2  font-semibold text-[#050505]">
                        See attachments{' '}
                      </h2>
                      {!files ||
                        (files.length === 0 && (
                          <div className="py-2 text-center text-[#ABABAB]">
                            No attachements
                          </div>
                        ))}
                      <ul>
                        {files.map((file) => (
                          <li
                            key={file.name}
                            className="flex items-center justify-between "
                          >
                            <div>
                              <img
                                src="https://assets.learntube.ai/files/Content_player/Attachment_Paper.png?ik-sdk-version=javascript-1.4.3&updatedAt=1662805197601"
                                alt="icon"
                                className="inline-block"
                              />
                              <span className="ml-2 font-medium text-[#707070] ">
                                {file.name}
                              </span>
                              <a
                                href={URL.createObjectURL(file)}
                                download={file.name}
                                className="ml-2 font-semibold text-[#29A4E9] underline"
                                target={'_blank'}
                                rel="noreferrer"
                              >
                                View
                              </a>
                            </div>
                            <span
                              onClick={() => removeFile(file.name)}
                              className=" cursor-pointer"
                            >
                              <img
                                src="https://assets.learntube.ai/files/Content_player/Group_5528.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968202822"
                                alt="icon"
                              />
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="flex flex-col items-center justify-between">
                    {spinner && (
                      <Spinner className="flex flex-col justify-center" />
                    )}
                    <button
                      className=" mb-5 block w-full rounded-lg bg-[#FFB763] px-8 py-1 text-base font-semibold text-[#0A0A0A] shadow-lg md:mx-4 md:mt-4 md:w-auto md:px-12 md:py-2"
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </>
              )}

              {!isUpgraded && submittedTask && (
                <div className="mt-3 flex flex-col w-full items-center justify-evenly py-3 md:mt-0 md:justify-center">
                  <GradeCard 
                   type="notupgraded"
                   user_task={taskSubmitted?.user_task}
                   />
                  <Gamification
                    callback={expertTaskHandler} // after coinds dedcution
                    modalType={userActivity?.ASK_TASK_REVIEW.type}
                    activityDetails={userActivity?.ASK_TASK_REVIEW}
                  >
                    <div className="flex flex-col mt-5 items-center justify-between">
                      <img
                        src="https://assets.learntube.ai/files/Content_player/Group_5532.png?ik-sdk-version=javascript-1.4.3&updatedAt=1663137813747"
                        alt="expert image"
                        srcset=""
                      />
                      <h2 className="py-2 text-[20px] font-semibold text-[#050505]">
                        Get an Expert Review
                      </h2>
                      <p className="text-[#050505]">
                        The free service ends here
                      </p>
                      <button
                        // disabled={currentDoubtsData.length > 0 ? false : true}
                        className="block rounded-lg bg-[#F69F38]  px-8 py-1 font-semibold text-[#272727] shadow-lg md:mx-4 md:mt-4 md:px-8 md:py-2 md:text-[20px]"
                        onClick={(e) => {
                          if (user_token) {
                            if (!isSubmitted) {
                              toast.info('Please submit your task first');
                              return;
                            }
                            e.stopPropagation();
                            setType(userActivity?.ASK_TASK_REVIEW.type);
                            setOpenConfirmationModal(true);
                          } else {
                            navigate('/login');
                          }
                        }}
                      >
                        Upgrade for Expert Review{' '}
                      </button>
                      <small className="mt-2">
                        200{' '}
                        <FontAwesomeIcon
                          icon={faCoins}
                          className="text-amber-500"
                        />
                      </small>
                    </div>
                  </Gamification>
                </div>
              )}

              {
                // isUpgraded && (
                <>
                  <h2 className="py-2 font-semibold text-[#050505]">Status</h2>
                  <p className="py-5 text-center font-medium italic text-[#3A3535]">
                    {taskExpertReviewStatus}
                  </p>
                </>
              }
            </div>
          )}
          {item === data[1] && (
            <div className="p-1 px-2">
              <GradeCard
                score={taskSubmitted?.user_task?.review_rating}
                feedback={taskSubmitted?.user_task?.review_feedback}
                image_link={taskSubmitted?.user_task?.certificate_image_link}
                type="submission"
                user_task={taskSubmitted?.user_task}
                status={task?.user_task?.reviewed_status}
              />
            </div>
          )}
          {item === data[2] && (
            <div className="p-1 px-2">
              <GradeCard
                score={taskSubmitted?.user_task?.review_rating_resubmission}
                feedback={
                  taskSubmitted?.user_task?.review_feedback_resubmission
                }
                image_link={taskSubmitted?.user_task?.certificate_image_link}
                type="resubmission"
                user_task={taskSubmitted?.user_task}
                status={task?.user_task?.reviewed_status}
              />
            </div>
          )}
        </Accordion>
      ))}
    </div>
  );
}
